import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { ContextualMenuItem } from "../../home/models/OtherTypes";
import { ProductAccessoryService } from "../services/ProductAccessoryService";

export default function useProductAccessoryVM() {
    const service = new ProductAccessoryService();

    const [brands, setBrands] = useState<ContextualMenuItem[]>([]);
    const [categories, setCategories] = useState<ContextualMenuItem[]>([]);
    const [categorySize, setCategorySize] = useState(Math.min(window.innerWidth / 4.2, 160));
    const [brandSize, setBrandSize] = useState(Math.min(window.innerWidth / 4.2, 100));

    const getBrands = () => {
        const onResult = (result: IDataResult) => {
            const brands = result.data as ContextualMenuItem[];

            if (result.status === ResponseStatus.success && brands) {
                setBrands(brands);
            }
        }

        const request = service.getTopBrands();
        DataUtils.onRequest(request, onResult);
    }

    const getCategories = () => {
        const onResult = (result: IDataResult) => {
            const categories = result.data as ContextualMenuItem[];

            if (result.status === ResponseStatus.success && categories) {
                setCategories(categories);
            }
        }

        const request = service.getTopCategories();
        DataUtils.onRequest(request, onResult);
    }

    const filteredCategories = (list: string[]) => {
        if (list.length > 0) {
            return categories.filter((cat) => !list.includes(cat.text));
        }

        return categories;
    }

    return {
        categorySize, setCategorySize,
        brandSize, setBrandSize,

        brands,
        categories,

        getBrands,
        getCategories,
        filteredCategories
    }
}